module.exports = __webpack_public_path__ + "img/fan-page.01703c14.webp";